'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _reactI18next = require('react-i18next');
var _urls = require('../../constants/urls');
var _urls2 = _interopRequireDefault(_urls);
var _numbers = require('../../helpers/numbers');
var _misc = require('../../helpers/misc');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var defaultShowPrice = true;
var styles = {
  loader: {
    display: 'block',
    margin: '2rem auto'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around'
  },
  card: {
    margin: '1rem',
    borderRadius: '0.5rem',
    textDecoration: 'none',
    color: 'inherit',
    padding: '1rem',
    background: '#EEE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    width: '8em',
    '&:hover': {
      background: '#DDD'
    },
    '& .registrationBaseInfo': {
      textAlign: 'center',
      '& .registrationTypeName': {
        maxWidth: '100%',
        wordWrap: 'break-word',
        fontSize: '1em'
      },
      '& .registrationTypePrice': {
        fontSize: '1.5em',
        marginTop: '1rem',
        maxWidth: '100%',
        overflow: 'hidden',
        overflowWrap: 'break-word'
      }
    },
    '& .registrationTypeAvailabilityWrapper': {
      textAlign: 'center',
      fontSize: '0.85em'
    }
  }
};
var RegistrationTypeCards = function (_Component) {
  _inherits(RegistrationTypeCards, _Component);
  function RegistrationTypeCards() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, RegistrationTypeCards);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegistrationTypeCards.__proto__ || Object.getPrototypeOf(RegistrationTypeCards)).call.apply(_ref, [this].concat(args))), _this), _this.renderAvailability = function (value) {
      var t = _this.props.t;
      return _react2.default.createElement('div', {
        className: 'registrationTypeAvailabilityWrapper'
      }, _react2.default.createElement('p', {
        className: 'registrationTypeAvailabilityValue'
      }, value), _react2.default.createElement('p', {
        className: 'registrationTypeAvailabilityInfo'
      }, t('registration.available_seats')));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(RegistrationTypeCards, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        classes = _props.classes,
        entities = _props.entities,
        pagination = _props.pagination,
        t = _props.t,
        otherProperties = _props.otherProperties;
      var showAvailability = otherProperties.showAvailability,
        showPrice = otherProperties.showPrice,
        showVAT = otherProperties.showVAT,
        displayedAttendeeTypes = otherProperties.displayedAttendeeTypes;
      var events = entities.events,
        attendee_types = entities.attendee_types;
      var isFetching = pagination.isFetching;
      var event = Object.keys(events).map(function (k) {
        return events[k];
      })[0];
      var eventUri = event.eventUri,
        eventId = event.id;
      var attendeeTypeIds = (0, _misc.filterAndSortAttendeeTypes)(attendee_types, displayedAttendeeTypes);
      return _react2.default.createElement('div', {
        className: classes.container
      }, isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.loader
      }) : !!attendeeTypeIds.length ? attendeeTypeIds.map(function (attendee_type) {
        return _react2.default.createElement('a', {
          key: attendee_type,
          className: classes.card,
          target: '_blank',
          href: !!parseInt(attendee_types[attendee_type].capacity) && !parseInt(attendee_types[attendee_type].availability) ? undefined : _urls2.default.getPublicRegisterUrl(eventUri, attendee_type, parseInt(eventId))
        }, _react2.default.createElement('div', {
          className: 'registrationBaseInfo'
        }, _react2.default.createElement('h3', {
          className: 'registrationTypeName'
        }, attendee_types[attendee_type].name), (showPrice === undefined && defaultShowPrice || showPrice != undefined && showPrice) && _react2.default.createElement('p', {
          className: 'registrationTypePrice'
        }, !parseFloat(attendee_types[attendee_type].price) ? t('event.price.free') : showVAT === undefined || showVAT ? (0, _numbers.addThousandsSeparator)(attendee_types[attendee_type].price) + ' ' + event.currency : (0, _numbers.addThousandsSeparator)(attendee_types[attendee_type].priceWithoutVat) + ' ' + event.currency)), !!showAvailability && !!attendee_types[attendee_type].capacity && _this2.renderAvailability(parseFloat(attendee_types[attendee_type].availability)));
      }) : _react2.default.createElement('h3', null, 'No attendee types :('));
    }
  }]);
  return RegistrationTypeCards;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(RegistrationTypeCards));